export class CloudPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "CloudPrincipalAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "CloudPrincipalGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
